import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

interface OnboardingGuardProps {
  children: React.ReactNode
}

export function OnboardingGuard({ children }: OnboardingGuardProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, hasCompletedOnboarding, setOnboardingComplete } = useAuthStore()

  useEffect(() => {
    // Skip check if already on onboarding page
    if (location.pathname === '/onboarding') {
      return
    }

    // Skip check if onboarding is already marked as complete
    if (hasCompletedOnboarding) {
      return
    }

    // Check if user has completed their profile
    // For now, we just check if user exists from auth
    // In future, when backend is ready, we can fetch full profile
    const checkOnboardingStatus = () => {
      // If user doesn't have the hasCompletedOnboarding flag,
      // redirect them to onboarding
      // New users from signup will go through onboarding
      // Old users need to complete it too
      const isComplete = user?.hasCompletedOnboarding === true

      if (isComplete) {
        setOnboardingComplete(true)
      } else {
        // Redirect to onboarding
        navigate('/onboarding', { replace: true })
      }
    }

    checkOnboardingStatus()
  }, [location.pathname, hasCompletedOnboarding, user, navigate, setOnboardingComplete])

  return <>{children}</>
}
